import Accordion from "../../../components/Accordion/Accordion";
import StatusBadge from "../../../components/StatusBadge/StatusBadge";
import { OrderDetail } from "../../../interfaces/interfaces";
import OrderHistoryDetails from "./OrderHistoryDetails/OrderHistoryDetails";

interface Props {
  order: OrderDetail;
  open?: boolean;
}

function OrderHistoryCard({ order, open = false }: Props) {
  function displayAccpacOrderId() {
    if (order.order_id) return order.order_id;
    if (order.status) return `${order.status.toUpperCase()}`;
    return "ERROR";
  }

  function getStatusBadge() {
    const status = order.status || "Pending";
    return <StatusBadge status={status} />;
  }

  function hasBackOrder() {
    const orderItems = order.order_items ? order.order_items : [];
    return orderItems.some((item) => item.backorder != null);
  }

  function getAccordionTitle() {
    return (
      <div className="order-history-card__title">
        <div className="order-history-card__title-left">
          <span className="order-history-card__order-id">Order #{displayAccpacOrderId()}</span>
          {order.po_number && (
            <span className="order-history-card__po-number">PO: {order.po_number}</span>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="order-history-card">
      <Accordion title={getAccordionTitle()} expanded={open}>
        <div className="order-history-card__content">
          <OrderHistoryDetails
            orderId={order.id}
            orderAccpacNo={order.order_id}
            order={order}
            statusBadge={getStatusBadge()}
            hasBackOrder={hasBackOrder()}
          />
        </div>
      </Accordion>
    </div>
  );
}

export default OrderHistoryCard;
